export const conferenceServiceItems = [
        {
            date: '2026',
            title:'General co-chair',
            text:'IEEE-ICC2026 Workshop on Workshop on Machine Learning and Deep Learning for Wireless Security'
        },
        {
            date: '2026',
            title:'Technical Program co-chair',
            text:'IEEE International Conference on high Performance Routing and Switching'
        },
        {
            date: '2025',
            title:'General co-chair',
            text:'IEEE-Globecom2025 Workshop on Workshop on Machine Learning and Deep Learning for Wireless Security'
        },
        {
            date: '2025',
            title:'General co-chair',
            text:'IEEE-ICC 2025 Workshop on Workshop on Machine Learning and Deep Learning for Wireless Security'
        },
        {
            date: '2024',
            title:'General co-chair',
            text:'IEEE-Globecom 2024 Workshop on Workshop on Machine Learning and Deep Learning for Wireless Security'
        },
        {
            date: '2024',
            title:'General co-chair',
            text:'IEEE-ICC 2024 Workshop on Workshop on Machine Learning and Deep Learning for Wireless Security'
        },
        {
            date: '2024',
            title:'General Chair',
            text:'IEEE World Forum on Internet of Things (WF-IoT)'
        },
        {
            date: '2024',
            title:'Technical Program Chair',
            text:'IEEE Canadian Conference on Electrical and Computer Engineering (CCECE)'
        },
        {
            date: '2024',
            title:'Symposium Co-Chair',
            text:'International Conference on Computing, Networking and Communications (ICNC): Social Computing and Data Mining'
        },
        {
            date: '2023',
            title:'Track Chair',
            text:'IEEE Vehicular Technology Conference (VTC)-Fall: Spectrum Management, Green Communications, Services and Security Track'
        },
        {
            date: '2023',
            title:'Workshop Chair',
            text:'ACM Multimedia (MM) Workshop on Advanced Multimedia Computing for Smart Manufacturing and Engineering'
        },
        {
            date: '2023',
            title:'General Co-Chair',
            text:'IEEE International Black Sea Conference on Communications and Networking (BlackSeaCom)'
        },
        {
            date: '2023',
            title:'Symposium Co-Chair',
            text:'IEEE Global Communications Conference (Globecom)-Selected Areas in Communications Social Networks'
        },
        {
            date: '2023',
            title:'Symposium Co-Chair',
            text:'International Conference on Computing, Networking and Communications (ICNC): Social Computing and Data Mining'
        },
        {
            date: '2022-Present',
            title:'Steering Committee Member',
            text:'IEEE International Black Sea Conference on Communications and Networking (BlackSeaCom)'
        },
        {
            date: '2022-Present',
            title:'Steering Committee Member',
            text:'IEEE International Workshop on Computer-Aided Modeling​, Analysis, and Design of Communication Links and Networks (CAMAD)'
        },
        {
            date: '2022',
            title:'Symposium Co-Chair',
            text:'IEEE/CIC International Conference on Communications in China (ICCC)-Wireless Networking and Multimedia Symposium'
        },
        {
            date: '2022',
            title:'Technical Program Co-Chair',
            text:'ACM Workshop on Wireless Security and Machine Learning (WiseML)'
        },
        {
            date: '2022',
            title:'Symposium Co-Chair',
            text:'IEEE International Conference on Communications (ICC)-Communication Reliability and Quality of Service Symposium'
        },
        {
            date: '2021',
            title:'Track Chair',
            text:'Security and Privacy Track, IEEE International Smart Cities Conference (ISC2)'
        },
        {
            date: '2021',
            title:'Track Chair',
            text:'IEEE Canadian Conference on Electrical and Computer Engineering- Cybersecurity in Systems Track'
        },
        {
            date: '2021',
            title:'Track Chair',
            text:'IEEE Wireless Days Conference (WD)-Track on Wireless and mobile networking technologies for fighting pandemics'
        },
        {
            date: '2021',
            title:'General Co-Chair',
            text:'IEEE International BlackSea Communications Conference (BlackSeaCom), Bucharest, Romania'
        },
        {
            date: '2021',
            title:'General Co-Chair',
            text:'IEEE International Workshop on Computer-Aided Modeling​, Analysis, and Design of Communication Links and Networks (CAMAD), Porto, Portugal'
        },
        {
            date: '2020',
            title:'Technical Program Co-Chair',
            text:'IEEE International BlackSea Conference on Communications and Networking (BlackSeaCom)'
        },
        {
            date: '2019',
            title:'Track Chair',
            text:'IEEE Vehicular Technology Conference (VTC -Fall): IoT, M2M, Sensor Networks, and Ad-Hoc Networking'
        },
        {
            date: '2019',
            title:'Symposium Co-Chair',
            text:'IEEE International Conference on Computing, Networking and Communications (ICNC): Machine Learning for Communication and Networking'
        },
        {
            date: '2019',
            title:'Track Chair',
            text:'IEEE International Conference on Cloud and Big Data Computing-Data Science Track'
        },
        {
            date: '2018',
            title:'Symposium Co-Chair',
            text:'IEEE Global Communications Conference (Globecom)-Communication Sys. QoS, Reliability and Modeling Symp.'
        },
        {
            date: '2018',
            title:'Program Co-Chair',
            text:'IEEE Mobile Cloud 18'
        },
        {
            date: '2018',
            title:'Program Co-Chair',
            text:'IEEE International Conference on Scalable Computing and Communications'
        },
        {
            date: '2018-Present',
            title:'Steering Committee Member',
            text:'IEEE ISCC Workshop on Management of Cloud and Smart City Systems (MoCS)'
        },
        {
            date: '2012-2017',
            title:'Workshop Co-Chair',
            text:'IEEE ISCC Workshop on Management of Cloud and Smart City Systems (MoCS)'
        },
        {
            date: '2014-2016',
            title:'Publicity Chair',
            text:'IEEE Reliable Networks Design and Modelling (RNDM) Workshop'
        },
        {
            date: '2016',
            title:'Technical Program Co-Chair',
            text:'ACM International Symposium on QoS and Security for Wireless and Mobile Networks (Q2SWinet)'
        },
        {
            date: '2016',
            title:'General Co-Chair',
            text:'IEEE International Workshop on Computer-Aided Modeling Analysis and Design of Communication Links and Networks (CAMAD)'
        },
        {
            date: '2016',
            title:'Technical Program Co-Chair',
            text:'IEEE Int. Symposium on Computers and Communications (ISCC)'
        },
        {
            date: '2016',
            title:'Technical Program Co-Chair',
            text:'The International Workshop on Big Data Analytics for Smart and Connected Health (BIGDATA4HEALTH)'
        },
        {
            date: '2015',
            title:'Workshop Co-Chair',
            text:'IEEE GLOBECOM Workshop on Cloud Computing Systems, Networks and Applications (CCSNA)'
        },
        {
            date: '2014',
            title:'Workshop Co-Chair',
            text:'IEEE GLOBECOM Workshop on Cloud Computing Systems, Networks and Applications (CCSNA)'
        },

    ];